/**
 * SPA hook for /api/categories — the distinct-categories endpoint that feeds
 * the category dropdown on /products and /brands. Cheap query; cached on
 * the SPA for 60s since the list rarely changes between searches.
 */
import { queryOptions, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { apiFetch } from './api';

export const ListCategoriesResponse = z.object({
  categories: z.array(z.string().min(1)),
});
export type ListCategoriesResponse = z.infer<typeof ListCategoriesResponse>;

export function categoriesQuery() {
  return queryOptions({
    queryKey: ['categories'] as const,
    queryFn: () =>
      apiFetch<ListCategoriesResponse>('/api/categories', {
        responseSchema: ListCategoriesResponse,
      }),
    staleTime: 60_000,
  });
}

export function useCategories() {
  return useQuery(categoriesQuery());
}
